<template>
    <main class="page-main">
        <article class="section-content static-page">

            <!-- Section content -->
            <div class="content-wrapper">
                <div class="content-inner">
                    <div class="content-thin">
                        <h1>{{$t('license')}}</h1>

                        <div class="txt-wrapper">
                            <p class="txt_imp">{{$t('licensePage.r0p0')}} <a :href="web">{{web}}</a>. {{$t('licensePage.r0p1')}}</p>
                            <p>{{$t('licensePage.r1p0')}}</p>

                            <h2>{{$t('licensePage.t1')}}</h2>
                            <p>{{$t('licensePage.r2p0')}}</p>
                            <p>{{$t('licensePage.r3p0')}}</p>
                            <p>{{$t('licensePage.r4p0')}}</p>

                            <h2>{{$t('licensePage.t2p0')}} <br>{{$t('licensePage.t2p1')}}</h2>
                            <p>{{$t('licensePage.r5p0')}}</p>
                            <ul>
                                <li>{{$t('licensePage.li0')}}</li>
                                <li>{{$t('licensePage.li1')}}</li>
                                <li>{{$t('licensePage.li2')}}</li>
                                <li>{{$t('licensePage.li3')}}</li>
                            </ul>

                            <h2>{{$t('licensePage.t3')}}</h2>
                            <p>{{$t('licensePage.r6p0')}}</p>
                            <p>{{$t('licensePage.r7p0')}}</p>
                            <p>{{$t('licensePage.r8p0')}}</p>
                            <p>{{$t('licensePage.r9p0')}}
                                <a :href="'tel:'+ phone">{{phone}}</a>{{$t('licensePage.r9p1')}}<a :href="'mailto:'+ email">{{email}}</a>.</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /Section content -->
        </article>

    </main>
</template>

<script>
    export default {
        name: "License",
        data(){
            return{
                web:   process.env.VUE_APP_WEB,
                phone: process.env.VUE_APP_CONTACT_PHONE,
                email: process.env.VUE_APP_CONTACT_EMAIL,
            }
        },
    }
</script>

<style scoped>
</style>